import React from "react";
import st from './empty.module.scss'

export const getEmptyTextBlock = () => {
    return (
        <div className={st.empty_block__text}>
            <h3 className={st.empty_block__text_title}>По выбранной культуре ещё нет данных</h3>
            <div className={st.empty_block__text_description}>Для просмотра этого графика выберите другую культуру</div>
        </div>
    );
};